import '@/fonts.css';
import '@/global.css';
import '@todo/core/scroll-restoration';

import { Stack } from 'expo-router';
import Head from 'expo-router/head';
import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from '@/lib/i18n';
import { rememberAiReferral } from '@todo/core/ai-referral';
import { SITE_NAME, webSiteJsonLd } from '@todo/core/seo';

// Base 'en' instance — only reaches the un-prefixed root redirect page. Every
// real page lives under app/[lang]/, whose layout provides the locale-scoped
// instance that shadows this one.
export default function RootLayout() {
  // Once per page load: note whether the visit came from an AI assistant, for
  // the `via` property of affiliate clicks (web only).
  useEffect(rememberAiReferral, []);

  return (
    <I18nextProvider i18n={i18n}>
      {/* Site-wide fallback; pages override it with their own <Head>. */}
      <Head>
        <title>{SITE_NAME}</title>
        <script type="application/ld+json">{JSON.stringify(webSiteJsonLd())}</script>
      </Head>
      <Stack screenOptions={{ headerShown: false }} />
    </I18nextProvider>
  );
}
